export default __webpack_public_path__ + "static/media/bg-stream-a-4.db177e8e.png";